import React, { useEffect, useState } from "react";
import API from "../api";

export default function About() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await API.get("/content");

    const data = res.data.find(
      (item) => item.type === "tentang"
    );

    setAbout(data);
  };

  return (
    <div className="container about">

      <h1 className="text-center mb-4">
        🏫 Tentang Kami
      </h1>

      {!about ? (
        <div className="card-visi">
          <h3>📌 Informasi Sekolah</h3>
          <p>Data tentang kami belum tersedia</p>
        </div>
      ) : (
        <div className="card-visi">

          <h3>
            🏫 {about.title || "Tentang PAUD Ceria"}
          </h3>

          <p>
            {about.description || "Belum ada deskripsi"}
          </p>

        </div>
      )}

    </div>
  );
}